





















import Vue from 'vue';

import FadeItem from './FadeItem.vue';
import Writing from './Writing.vue';

export default Vue.extend({
  name: 'Bubble',
  components: {
    FadeItem,
    Writing,
  },
  props: {
    banner: Boolean,
    delay: String,
    fast: Boolean,
    onAnimate: {
      type: Function,
      default: () => null,
    },
    plain: Boolean,
    received: Boolean,
    small: Boolean,
  },
  data() {
    return {
      writing: (!this.received) as boolean,
    };
  },
  mounted() {
    if (this.delay) {
      const itemStyle = (this.$refs.bubble as HTMLElement).style;
      itemStyle.webkitAnimationDelay = this.delay;
      itemStyle.animationDelay = this.delay;
    }
  },
  methods: {
    onAppear(): void {
      if (this.writing) {
        const time: number = this.fast
          ? 500
          : 2500; // same as $bubbleDelay scss var

        setTimeout(() => {
          this.writing = false;
          this.onAnimate();
        }, time);
      } else {
        this.onAnimate();
      }
    },
  },
});
